module.exports = __webpack_public_path__ + "static/media/Phone_machDetail.2b13b7bf.png";